module.exports = {"TXTWCL_WeXre_working_on_this":{"id":"TXTWCL_WeXre_working_on_this","defaultMessage":"Me töötame selle kallal"}}